module.exports = __webpack_public_path__ + "img/title_short_bg.18e92f75.png";